export default {"src":"/_next/static/media/close-black.c7afadbd.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};